/**
 * Copyright © IMPACT Commerce AB. All rights reserved.
 * See COPYING.txt for license details.
 */

/**
 * The signed-out account drawer's sign-in buttons (blocks/_account-drawer-login.liquid).
 *
 * Signing in from the drawer is joining, so a sign-in started here leaves a flag for the way
 * back: the page the shopper returns to opens the drawer, opts them in and shows their welcome
 * code (assets/account-membership.js).
 *
 * Loaded on signed-out pages only, so it also forgets the membership status a signed-in page
 * kept: whichever way the shopper logged out, the session it belonged to is over.
 */

// Read and cleared by assets/account-membership.js; also checked inline in
// blocks/_account-drawer-signed-in.liquid.
const JOIN_FLAG = 'membership:join';

// The prefix assets/account-membership.js keeps each customer's status under.
const STATUS_KEY_PREFIX = 'membership:status:';

try {
  for (const key of Object.keys(sessionStorage)) {
    if (key.startsWith(STATUS_KEY_PREFIX)) sessionStorage.removeItem(key);
  }
} catch {
  // Storage blocked: nothing was kept.
}

class AccountSignIn extends HTMLElement {
  connectedCallback() {
    // Capture phase: the Shop button signs in on its own click handler, and the flag is set
    // whatever that handler does with the click.
    this.addEventListener('click', this.#handleClick, true);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick, true);
  }

  /** @param {MouseEvent} event */
  #handleClick = (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('.account-drawer__sign-in-buttons')) return;

    try {
      sessionStorage.setItem(JOIN_FLAG, String(Date.now()));
    } catch {
      // Storage blocked: the sign-in goes ahead as an ordinary one.
    }
  };
}

if (!customElements.get('account-sign-in')) customElements.define('account-sign-in', AccountSignIn);
